
<script>
import {
	CacheService
} from "@/service/common";
import {mapState} from "vuex"
  export default {
    data() {
      return {
        openIndex: [],
        activeIndex: "",
      };
    },
    computed:{
      ...mapState(["menu"]),
    },
    mounted() {
      this.$store.dispatch("getMenuData");
      this.openIndex = this.$route.matched.map((item) => item.path);

      this.$nextTick(()=>{
        this.activeIndex =this.$route.path
      });

    },
    methods: {
      renderSubmit(h, parent) {
        if (parent.children && parent.children.length) {
          if (parent.visible===false) return;
          return (
            <el-submenu index={parent.menuPath}>
              <template slot="title">
                <i class={["iconfont",parent.menuIcon]}style="color:white;margin-right:5px"></i>
                {parent.authName}</template>
              {parent.children.map((child) => {
                return this.renderSubmit(h, child);
              })}
            </el-submenu>
          );
        } else {
          if (parent.visible===false) return;
            return (
                <el-menu-item key={parent.menuPath} index={parent.menuPath}>
                  <i class={["iconfont",parent.menuIcon]}style="color:white;margin-right:5px"></i>
                  {parent.authName}
                </el-menu-item>
            );
        }
      },
    },
    render(h) {
      return (
        <el-menu
          router
          background-color="#282c34"
          text-color="#ffffff"
          active-text-color="#ffffff"
          unique-opened
          default-openeds={this.openIndex}
          default-active={this.activeIndex}
        >
          {this.menu.map((data) => this.renderSubmit(h, data))}
        </el-menu>
      );
    },
  };
</script>
